import React from 'react';

import { AsbuiltPoint } from '../../../../../../../typings/api/integrations/xsite/rest/v1/skymap-xsite-connection';
import { DataTable, DataTableProps } from '../../../data-table/data-table';

export type AsbuiltGeometryProps = {
  type: 'asbuilt-geometry';
  data: Pick<DataTableProps<AsbuiltPoint>, 'columns' | 'items'>;
};

export const AsbuiltProperties = (props: { data: AsbuiltGeometryProps['data'] }) => {
  return (
    <DataTable
      {...props.data}
      flip={true}
      tableStyle={{ headerCell: { backgroundColor: 'unset' } }}
    />
  );
};
